import { relativeTime } from '../../lib/format';
import { Severity, StatusBadge } from '../../ui/Badges';
import { useToast } from '../../ui/Toasts';
import { errorMessage } from '../../app/api';
import type { RegistryEntry, WidgetComponentProps } from '../types';

function AlertList({ data, props, ctx }: WidgetComponentProps) {
  const toast = useToast();
  const alerts: any[] = data.alerts ?? [];
  if (!alerts.length) return <div className="state"><strong>All clear</strong>No alerts match this view.</div>;
  return (
    <ul className="alerts">
      {alerts.map((a) => (
        <li key={a.id}>
          <Severity level={a.severity} />
          <div style={{ fontWeight: 600, minWidth: 0 }}>{a.title.replace(/ — [^—]+$/, '')}</div>
          <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
            {a.status !== 'active' && <StatusBadge status={a.status} />}
            {props.allowAcknowledge && a.status === 'active' && (
              <button
                className="btn sm"
                onClick={async () => {
                  try {
                    await ctx.action('acknowledge', a.id);
                    toast('Alert acknowledged', 'success');
                  } catch (e) {
                    toast(errorMessage(e), 'error');
                  }
                }}
              >
                Acknowledge
              </button>
            )}
          </div>
          <div className="msg">
            {a.message}
            <div
              className="muted"
              style={{ fontSize: 12, marginTop: 2 }}
              title={`First seen ${relativeTime(a.firstSeen)}${a.routing?.length ? ` · routes to ${a.routing.join(', ')}` : ''}${a.acknowledgedBy ? ` · acknowledged by ${a.acknowledgedBy}` : ''}`}
            >
              {a.storeName ? `${a.storeName} · ` : ''}
              {relativeTime(a.lastSeen)}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}

export const alertList: RegistryEntry = {
  component: AlertList,
  toTable: (d) => ({
    columns: [
      { key: 'severity', label: 'Severity', format: 'status' },
      { key: 'title', label: 'Alert' },
      { key: 'message', label: 'Detail' },
      { key: 'status', label: 'Status', format: 'status' },
      { key: 'lastSeen', label: 'Last seen', format: 'datetime' },
    ],
    rows: d?.alerts ?? [],
  }),
};
